import {Component, Inject, TemplateRef, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {IoTDeviceConfigurationObject,} from "../../../ParseClass/IoTDeviceConfiguration.Parse";
import {AbstractControl, FormGroup, UntypedFormBuilder, Validators} from "@angular/forms";
import {BehaviorSubject, EMPTY, Observable} from "rxjs";
import {
    PidActuator,
    PidConfiguration,
    PidConfigurationSeasonEnum,
    PidConfigurationTargetOpEnum,
    PidConfigurationTargetTypeEnum,
    PidInput
} from "../../../ParseClass/pid_configurations";
import {map, startWith} from "rxjs/operators";
import {HunaValidators} from "../../../providers/validators/HunaValidators";
import {
    arrayIsSet,
    GlobalVariablesService,
    objectIsSet,
    stringIsSet,
    typeRole
} from "../../../providers/service/global-variables.service";
import {ElementParse} from "../../../ParseClass/Element.Parse";
import {AlertService} from "../../../providers/service/alert.service";
import {IconService} from "../../../providers/service/icon.service";
import {SensorDataTypesParse} from "../../../ParseClass/sensor-data-types-parse";
import {SensorEventType} from "../../../ParseClass/SensorEvent.Parse";
import {TranslateService} from "@ngx-translate/core";
import {dataForm, GroupDataForm} from "../../../widget/auto-complete-form/auto-complete-form.component";

@Component({
    selector: 'app-update-iot-pid-configurations',
    templateUrl: './update-iot-pid-configurations.component.html',
    styleUrls: ['./update-iot-pid-configurations.component.scss'],
    standalone: false
})
export class UpdateIotPidConfigurationsComponent {
    public form: FormGroup;
    public pidConfigurations$: Observable<PidConfiguration[] | undefined>
    actuatorField$: Observable<PidActuator>
    actuatorFieldSensorId$: Observable<string | undefined>
    actuatorFieldSensorPValues$: Observable<GroupDataForm[] | undefined>
    typeTargetField$: Observable<number | undefined>
    inputFieldSensorId$: Observable<string | undefined>
    inputFieldSensorPValues$: Observable<GroupDataForm[] | undefined>
    inputTargetFieldSensorId$: Observable<string | undefined>
    inputTargetFieldSensorPValues$: Observable<GroupDataForm[] | undefined>
    possibleTypesTargetInput = PidConfigurationTargetTypeEnum
    possibleTypesTargetOp = PidConfigurationTargetOpEnum
    public errorActuatorField$: Observable<string | undefined>
    public invalidActuatorField$: Observable<boolean | undefined>
    public errorInputField$: Observable<string | undefined>
    public invalidInputField$: Observable<boolean | undefined>
    @ViewChild('ACTUATORFIELD') private ACTUATORFIELDRef: TemplateRef<any> | undefined;
    @ViewChild('INPUTFIELD') private INPUTFIELDRef: TemplateRef<any> | undefined;
    private modifyDialogRef: MatDialogRef<any> | undefined
    seasonTypes = PidConfigurationSeasonEnum
    enableChangesEmit = new BehaviorSubject(false)
    enableChanges$: Observable<boolean> = this.enableChangesEmit.asObservable();
    enableChangesTraduction$: Observable<string>;
    isEditor = false
    tsInstant

    constructor(public dialogRef: MatDialogRef<UpdateIotPidConfigurationsComponent>,
                private dialog: MatDialog,
                private alertService: AlertService,
                private iconService: IconService,
                @Inject(MAT_DIALOG_DATA) public data: {
                    currentPidConfigurations: PidConfiguration[],
                    configNotSaved?: IoTDeviceConfigurationObject,
                    elements: ElementParse[],
                    sensorDataTypes: SensorDataTypesParse[],
                    isEditor: boolean | undefined
                },
                private fb: UntypedFormBuilder,
                private ts: TranslateService,
                private globalVariablesService: GlobalVariablesService,
    ) {
        this.tsInstant = (t: string) => this.ts.instant(t)
        iconService.addSvgIcon('<', 'assets/icon/math/less.svg');
        iconService.addSvgIcon('=', 'assets/icon/math/equals.svg');
        iconService.addSvgIcon('>', 'assets/icon/math/greather.svg');
        iconService.addSvgIcon('winterSummer', '/assets/icon/temperature/estateInverno.svg')
        this.isEditor = this.data.isEditor == true
        this.form = this.fb.group({
            pidConfigurations: [undefined, [Validators.required, HunaValidators.arrayOfArrayIsSet('arrayEmptyStatement')]],
            actuatorField: this.fb.group({
                command: [undefined, [Validators.required]],
                sensorId: [undefined, [Validators.required]],
                infoName: [undefined, [Validators.required]],
                minValue: [undefined,],
                maxValue: [undefined,],
            }),
            inputField: this.fb.group({
                infoName: [undefined, [Validators.required]],
                sensorId: [undefined, [Validators.required]],
                type: [undefined, [Validators.required]],
                target: [undefined, [Validators.required]],
                target_op: [undefined, [Validators.required]],
                targetSensor: fb.group({
                    sensorId: [undefined, [Validators.required]],
                    infoName: [undefined, [Validators.required]],
                }),
                targetScenario: fb.group({
                    sensorId: [undefined, [Validators.required]],
                }),
                max_step_up: [undefined],
                max_step_down: [undefined],
                k_p: [undefined, [Validators.required]],
                k_i: [undefined, [Validators.required]],
                k_d: [undefined, [Validators.required]],
                i_max: [undefined,],
            }),

        })
        this.pidConfigurations$ = this.form.get('pidConfigurations')!.valueChanges.pipe(
            startWith(undefined),
            map(() => {
                return this.pidConfigurations
            })
        )
        if (this.data) {
            if (arrayIsSet(this.data.currentPidConfigurations)) {
                this.pidConfigurations = this.data.currentPidConfigurations;
            }
        }
        this.actuatorField$ = this.actuatorField.valueChanges.pipe(
            startWith(undefined),
            map(() => {
                return this.actuatorField.value
            })
        )
        this.actuatorFieldSensorId$ = this.actuatorField$.pipe(
            map(() => {
                return this.actuatorField.get('sensorId')?.value
            })
        )
        this.actuatorFieldSensorPValues$ = this.actuatorFieldSensorId$.pipe(
            map((id) => {
                return this.getPeriodicDataGroupsPredicate(id)
            })
        )
        this.actuatorField$ = this.actuatorField.valueChanges.pipe(
            startWith(undefined),
            map(() => {
                return this.actuatorField.value
            })
        )

        this.invalidActuatorField$ = this.actuatorField$.pipe(
            map(() => this.actuatorField.invalid)
        )
        this.errorActuatorField$ = this.invalidActuatorField$.pipe(
            map((invalid) => {
                if (invalid) {
                    return 'allFieldsIsRequired'
                } else {
                    return undefined;
                }
            })
        )
        const inputField$ = this.inputField.valueChanges.pipe(
            startWith(undefined),
            map(() => {
                return this.inputField.value;
            })
        )
        this.inputFieldSensorId$ = inputField$.pipe(
            map(() => {
                return this.inputField.get('sensorId')?.value
            })
        )
        this.inputFieldSensorPValues$ = this.inputFieldSensorId$.pipe(
            map((id) => {
                return this.getPeriodicDataGroupsPredicate(id)
            })
        );
        this.inputTargetFieldSensorId$ = inputField$.pipe(
            map(() => {
                return this.inputField.get('targetSensor')!.get('sensorId')?.value
            })
        )
        this.inputTargetFieldSensorPValues$ = this.inputTargetFieldSensorId$.pipe(
            map(id => this.getPeriodicDataGroupsPredicate(id))
        )
        this.typeTargetField$ = inputField$.pipe(
            map(() => {
                return this.inputField.get('type')?.value
            })
        )
        this.invalidInputField$ = inputField$.pipe(
            map(() => {
                const type = this.inputField.get('type')?.value
                const keysTarget = ['target', 'targetSensor', 'targetScenario']
                const keysToInvalid = Object.keys(this.inputField.value)
                    .filter(key => {
                        if (keysTarget.includes(key)) {
                            if (type == this.possibleTypesTargetInput.SENSOR) {
                                return key == 'targetSensor'
                            } else if (type == this.possibleTypesTargetInput.SCENARIO) {
                                return key == 'targetScenario'
                            } else {
                                return key == 'target'
                            }
                        }
                        return true
                    })
                const invalid = keysToInvalid
                    .findIndex(key => {
                        let keyInvalid = this.inputField.get(key)?.invalid
                        return keyInvalid
                    }) >= 0
                return invalid
            })
        )
        this.errorInputField$ = this.invalidInputField$.pipe(
            map((invalid) => {
                if (invalid) {
                    return 'allFieldsIsRequired'
                } else {
                    return undefined;
                }
            })
        )
        this.enableChangesTraduction$ = this.enableChanges$.pipe(
            map((status) => {
                return status ? 'disableChanges' : 'enableChanges'
            })
        )
    }

    clickSaveButton() {
        const pidConfigurations = this.pidConfigurations?.map(pid => {
            const pidParse = new PidConfiguration(undefined)
            const inputsPid = pid.inputs?.map((inputJson: any) => {
                const input = new PidInput(inputJson.sensorId, inputJson.infoName, inputJson.type)

                const notKeys = ['sensorId', 'type']
                Object.keys(inputJson).forEach(key => {
                    if (!notKeys.includes(key) && key in input) {
                        (input as any)[key] = inputJson[key]
                    }
                })
                return input
            })
            pidParse.inputs = inputsPid
            const actuatorJson = pid.actuator!
            if (actuatorJson != null) {
                pidParse.actuator = new PidActuator(actuatorJson.sensorId, actuatorJson.command, actuatorJson.infoName, actuatorJson.maxValue, actuatorJson.minValue)
            }
            if (pid.ms_between_executions != null) {
                pidParse.ms_between_executions = pid.ms_between_executions
            }
            if (pid.season != null) {
                pidParse.season = pid.season
            }
            return pidParse
        })
        this.dialogRef.close({pidConfigurations})
    }

    get pidConfigurations(): PidConfiguration[] | undefined {
        return this.form.get('pidConfigurations')?.value
    }

    set pidConfigurations(value) {
        if (arrayIsSet(value)) {
            this.form.get('pidConfigurations')?.setValue(value)
        } else {
            this.form.get('pidConfigurations')?.setValue([])

        }
    }


    get actuatorField(): AbstractControl<any, any> {
        return this.form.get('actuatorField')!
    }

    get inputField(): AbstractControl<any, any> {
        return this.form.get('inputField')!
    }


    addPidConfigurations() {
        const pidConfigurations = arrayIsSet(this.pidConfigurations) ? [...this.pidConfigurations] : [];
        pidConfigurations.push(new PidConfiguration({}))
        this.pidConfigurations = pidConfigurations;
    }

    clonePidConfigurations(indexPidConfigurations: number) {
        if (arrayIsSet(this.pidConfigurations)) {
            const pidConfigurations = arrayIsSet(this.pidConfigurations) ? [...this.pidConfigurations] : [];
            pidConfigurations.push(new PidConfiguration(pidConfigurations[indexPidConfigurations]))
            this.pidConfigurations = pidConfigurations;

        }
    }

    removePidConfigurations(indexPidConfigurations: number) {
        if (arrayIsSet(this.pidConfigurations)) {
            const pidConfigurations = [...this.pidConfigurations];
            pidConfigurations.splice(indexPidConfigurations, 1);
            this.pidConfigurations = arrayIsSet(pidConfigurations) ? pidConfigurations : undefined;
        }
    }

    addInputToPidConfigurations(input: PidInput, indexPidConfigurations: number) {
        const pidConfigurations = arrayIsSet(this.pidConfigurations) ? [...this.pidConfigurations] : [];
        pidConfigurations[indexPidConfigurations].inputs?.push(input);
        this.pidConfigurations = pidConfigurations;
    }

    removeInputToPidConfigurations(indexPidConfigurations: number, indexInput: number) {
        if (arrayIsSet(this.pidConfigurations) && this.pidConfigurations[indexPidConfigurations] && arrayIsSet(this.pidConfigurations[indexPidConfigurations].inputs)) {
            const pidConfigurations = [...this.pidConfigurations];
            pidConfigurations[indexPidConfigurations]?.inputs?.splice(indexInput, 1);
            if (!arrayIsSet(pidConfigurations[indexPidConfigurations]?.inputs)) {
                pidConfigurations.splice(indexPidConfigurations, 1);
            }
            this.pidConfigurations = pidConfigurations;
        }
    }

    openDialogForm(matDialogRef: TemplateRef<any>): MatDialogRef<any> {
        return this.dialog.open(matDialogRef, {
            width: '100%',
            maxWidth: '100%',
            autoFocus: false,
            exitAnimationDuration: 0.1,
            disableClose: true
        })
    }

    dialogActuators$() {
        if (this.ACTUATORFIELDRef != null && this.changesEnabled) {
            this.modifyDialogRef?.close();
            this.modifyDialogRef = this.openDialogForm(this.ACTUATORFIELDRef);
            return this.modifyDialogRef.afterClosed()
        } else {
            return EMPTY
        }
    }


    removeActuators(indexPid: number) {
        const pidConfigurations = arrayIsSet(this.pidConfigurations) ? [...this.pidConfigurations] : []
        if (pidConfigurations[indexPid] != null && pidConfigurations[indexPid].actuator != null) {
            pidConfigurations[indexPid].actuator = undefined
            this.pidConfigurations = pidConfigurations;
        }
    }

    addActuators(indexPid: number) {
        const pidConfigurations = arrayIsSet(this.pidConfigurations) ? [...this.pidConfigurations] : []
        if (pidConfigurations[indexPid] != null && pidConfigurations[indexPid].actuator != null) {
            const pidConfigurationActuator = pidConfigurations[indexPid].actuator!;
            Object.keys(this.actuatorField.value).forEach((key: string) => {
                if (key in pidConfigurationActuator && (pidConfigurationActuator as any)[key] != null) {
                    this.actuatorField.get(key)?.setValue((pidConfigurationActuator as any)[key])
                } else {
                    this.actuatorField.get(key)?.reset();
                }
            })
        } else if (indexPid > 0) {
            this.alertService.warning('error');
        }
        this.dialogActuators$().subscribe(valuesAcutators => {
            if (valuesAcutators != null) {
                const pidConfiguration = pidConfigurations[indexPid];
                pidConfiguration.actuator = valuesAcutators;
                pidConfigurations[indexPid] = pidConfiguration;
                this.pidConfigurations = pidConfigurations;
            }
        }, error => {
            console.log(error)
        });
    }

    clickSaveActuators() {
        this.modifyDialogRef?.close(this.actuatorField.value);
        this.actuatorField.reset();

    }

    closeDialogActuator() {
        this.modifyDialogRef?.close(undefined);
        this.actuatorField.reset();
    }

    clickSaveInput() {
        this.modifyDialogRef?.close(this.inputField.value);
        this.inputField.reset();
    }

    closeDialogInput() {
        this.modifyDialogRef?.close(undefined);
        this.inputField.reset();
    }

    dialogInput$() {
        if (this.INPUTFIELDRef != null && this.changesEnabled) {
            this.modifyDialogRef?.close();
            this.modifyDialogRef = this.openDialogForm(this.INPUTFIELDRef);
            return this.modifyDialogRef.afterClosed()
        } else {
            return EMPTY
        }
    }

    removeInput(indexPid: number, indexInput: number | undefined) {
        const pidConfigurations = arrayIsSet(this.pidConfigurations) ? [...this.pidConfigurations] : []
        if (pidConfigurations[indexPid] != null && indexInput != null && arrayIsSet(pidConfigurations[indexPid].inputs) && pidConfigurations[indexPid].inputs![indexInput] != null) {
            const inputs = structuredClone(pidConfigurations[indexPid].inputs)
            inputs?.splice(indexInput, 1);
            pidConfigurations[indexPid].inputs = inputs;
            this.pidConfigurations = pidConfigurations;
        }
    }

    addInput(indexPid: number, indexInput: number | undefined) {
        const pidConfigurations = arrayIsSet(this.pidConfigurations) ? [...this.pidConfigurations] : []
        if (pidConfigurations[indexPid] != null && indexInput != null && arrayIsSet(pidConfigurations[indexPid].inputs) && pidConfigurations[indexPid].inputs![indexInput] != null) {
            const pidConfigurationInput = pidConfigurations[indexPid].inputs![indexInput]!;
            const notSetKeys = ['target', 'targetSensor', 'targetScenario',]
            Object.keys(this.inputField.value)
                .filter(key => !notSetKeys.includes(key))
                .forEach((key: string) => {
                    if (key in pidConfigurationInput && (pidConfigurationInput as any)[key] != null) {
                        this.inputField.get(key)?.setValue((pidConfigurationInput as any)[key])
                    } else {
                        this.inputField.get(key)?.reset();
                    }
                })
            const target = pidConfigurationInput.target
            if (this.inputField.get('type')?.value == null) {
                this.inputField.get('type')?.setValue(this.possibleTypesTargetInput.FIXED)
            }
            const type = this.inputField.get('type')?.value
            if (type == this.possibleTypesTargetInput.FIXED) {
                this.inputField.get('target')?.setValue(target)
            } else if (type == this.possibleTypesTargetInput.SENSOR) {
                this.inputField.get('targetSensor')?.setValue(target)
            } else if (type == this.possibleTypesTargetInput.SCENARIO) {
                this.inputField.get('targetScenario')?.setValue(target)
            }


        } else if (indexPid > 0) {
            this.alertService.warning('error');
        }
        if (this.inputField.get('type')?.value == null) {
            this.inputField.get('type')?.setValue(this.possibleTypesTargetInput.FIXED)
        }
        if (this.inputField.get('target_op')?.value == null) {
            this.inputField.get('target_op')?.setValue(this.possibleTypesTargetOp.EQUAL)
        }

        this.dialogInput$()
            .subscribe(jsonInput => {
                if (jsonInput != null) {
                    const type = jsonInput.type
                    if (type == null || type == this.possibleTypesTargetInput.FIXED) {
                    } else if (type == this.possibleTypesTargetInput.SCENARIO && jsonInput['targetScenario']) {
                        jsonInput['target'] = jsonInput['targetScenario']
                        delete jsonInput['targetScenario']
                    } else if (type == this.possibleTypesTargetInput.SENSOR && jsonInput['targetSensor']) {
                        jsonInput['target'] = jsonInput['targetSensor']

                    }
                    if (jsonInput['targetSensor']) {
                        delete jsonInput['targetSensor']
                    }
                    if (jsonInput['targetScenario']) {
                        delete jsonInput['targetScenario']
                    }
                    const valueInput = new PidInput(jsonInput.sensorId, jsonInput.infoName, jsonInput.type, jsonInput)
                    const pidConfiguration = pidConfigurations[indexPid];
                    const inputs = arrayIsSet(pidConfiguration.inputs) ? [...pidConfiguration.inputs] : []
                    if (indexInput == null || inputs[indexInput] == null) {
                        inputs.push(jsonInput);
                    } else {
                        inputs[indexInput] = jsonInput
                    }
                    pidConfiguration.inputs = inputs;
                    pidConfigurations[indexPid] = pidConfiguration;
                    this.pidConfigurations = pidConfigurations;
                    this.inputField.reset();
                }
            }, error => {
                console.log(error)
            });
    }

    // getOnlyElementsWhitPossibleCommandsPeriodicDataPredicate(elements: ElementParse[]): any[] | undefined {
    //     if (arrayIsSet(elements)) {
    //         return elements.filter(el => {
    //             const type: any = el.type
    //             return type && objectIsSet(type.possibleCommands) && objectIsSet(type.periodicData)
    //         })
    //     }
    //     return undefined
    // }

    // getElementsWhitPossibleCommandsPeriodicDataPredicate(elements: ElementParse[]): any[] | undefined {
    //     if (arrayIsSet(elements)) {
    //
    //         let groups: GroupDataForm[] = []
    //         groups.push({
    //             groupName: this.ts.instant('suggested'),
    //             possibleValues: elements.filter(el => {
    //                 const type: any = el.type
    //                 return type && objectIsSet(type.possibleCommands) && objectIsSet(type.periodicData)
    //             }).map(el => {
    //                 const obj: dataForm = {
    //                     valueForm: el.objectId,
    //                     html: el.name,
    //                     traduction: undefined,
    //                 }
    //                 return obj
    //             })
    //         });
    //         groups.push({
    //             groupName: this.ts.instant('other'),
    //             possibleValues: elements.filter(el => {
    //                 const type: any = el.type
    //                 return type ==null||!objectIsSet(type.possibleCommands) || !objectIsSet(type.periodicData)
    //             }).map(el => {
    //                 const obj: dataForm = {
    //                     valueForm: el.objectId,
    //                     html: el.name,
    //                     traduction: undefined,
    //                 }
    //                 return obj
    //             })
    //         })
    //         return groups
    //     }
    //     return undefined
    // }

    getOnlyElementsWhitCategoryTHERMOSTAT(elements: ElementParse[]): any[] | undefined {
        if (arrayIsSet(elements)) {
            const filtered = elements.filter(el => {
                const type: any = el.type
                return type && type.category == 'THERMOSTAT'
            })
            return filtered
        }
        return undefined
    }

    getOnlyElementsWhitPeriodicDataPredicate(elements: ElementParse[]): any[] | undefined {
        if (arrayIsSet(elements)) {
            return elements.filter(el => {
                const type: any = el.type
                return type && objectIsSet(type.periodicData)
            })
        }
        return undefined
    }

    getInputsIdsUsedPredicate(pidConfigurations: PidConfiguration[]): any[] | undefined {
        if (arrayIsSet(pidConfigurations)) {
            const idsUsed: string[] = pidConfigurations.reduce((ids, current) => {
                if (arrayIsSet(current.inputs)) {
                    current.inputs.forEach(input => {
                        const sensorId = input.sensorId!
                        ids.push(sensorId);
                    })
                }

                return ids;
            }, [] as string[])
            return idsUsed
        }
        return undefined
    }

    getActuatorIdsUsedPredicate(pidConfigurations: PidConfiguration[]): any[] | undefined {
        if (arrayIsSet(pidConfigurations)) {
            const idsUsed: string[] = pidConfigurations.reduce((ids, current) => {
                if (objectIsSet(current.actuator)) {
                    const sensorId = current.actuator.sensorId!
                    ids.push(sensorId);
                }
                return ids;
            }, [] as string[])
            return idsUsed
        }
        return undefined
    }

    getPossibleCommandsPredicate(sensorId: string | undefined, elements: ElementParse[]): any[] | undefined {
        if (stringIsSet(sensorId) && arrayIsSet(elements)) {
            const element = elements.find(el => el.objectId === sensorId)
            if (element != null && element.type && objectIsSet(element.type.possibleCommands)) {
                return Object.keys(element.type.possibleCommands)
            }
        }
        return undefined
    }

    getPeriodicDataPredicate(sensorId: string | undefined, elements: ElementParse[], sensorDataTypes: SensorDataTypesParse[]): any[] | undefined {
        if (stringIsSet(sensorId) && arrayIsSet(elements)) {
            const element = elements.find(el => el.objectId === sensorId)
            if (element == null || element.type == null) {
                return undefined
            } else if (objectIsSet(element.type.periodicData)) {
                return Object.keys(element.type.periodicData)
            } else if (arrayIsSet(sensorDataTypes)) {
                return sensorDataTypes.map(sensor => sensor.name)
            }
        }
        return undefined
    }

    getPeriodicDataGroupsPredicate(sensorId: string | undefined): GroupDataForm[] | undefined {
        if (stringIsSet(sensorId) && arrayIsSet(this.data.elements)) {
            const element = this.data.elements.find(el => el.objectId === sensorId)
            const sensorDataTypes = this.globalVariablesService.sensorDataType
            let keysPeriodicData: string[] = []
            let groups: GroupDataForm[] = []
            if (element) {
                if (element.type && objectIsSet(element.type.periodicData)) {
                    keysPeriodicData = Object.keys(element.type.periodicData)
                    groups.push({
                        groupName: this.ts.instant('suggested'),
                        possibleValues: keysPeriodicData.map(key => {
                            const obj: dataForm = {
                                valueForm: key,
                                html: key,
                                traduction: this.globalVariablesService.instantSensorDataTypeTraduction(key, this.ts.currentLang)!,
                            }
                            return obj
                        })
                    });
                }
                groups.push({
                    groupName: this.ts.instant('other'),
                    possibleValues: this.globalVariablesService.sensorDataType!.filter(sensorData => !keysPeriodicData.includes(sensorData.name!))
                        .map(key => {
                            const obj: dataForm = {
                                valueForm: key.name!,
                                html: key.name!,
                                traduction: this.globalVariablesService.instantSensorDataTypeTraduction(key.name, this.ts.currentLang)!,
                            }
                            return obj
                        })
                })
            }
            return groups
        }
        return undefined
    }

    getElementNamePredicate(sensorId: string | undefined, elements: ElementParse[]): string | undefined {
        if (stringIsSet(sensorId) && arrayIsSet(elements)) {
            const element = elements.find(el => el.objectId === sensorId)
            if (element != null) {
                return stringIsSet(element.name) ? element.name : element.objectId
            }
        }
        return undefined
    }

    getSensorNamePredicate(actuator: PidActuator, elements: ElementParse[]): string | undefined {
        if (actuator && stringIsSet(actuator.sensorId) && arrayIsSet(elements)) {
            const el = elements.find(el => el?.objectId === actuator?.sensorId)
            return el != null ? el.name : undefined
        } else {
            return undefined
        }
    }

    getPidConfigurationMs_between_executions(pid: PidConfiguration) {
        if (pid.ms_between_executions != null) {
            return pid.ms_between_executions / 1000
        } else {
            return 0
        }
    }

    setMs_between_executions(value: any, indexPid: number) {
        const pidConfigurations = arrayIsSet(this.pidConfigurations) ? [...this.pidConfigurations] : []
        const pidConfiguration = pidConfigurations[indexPid]
        if (pidConfiguration.ms_between_executions != value * 1000) {
            pidConfiguration.ms_between_executions = value * 1000;
            this.pidConfigurations = pidConfigurations;
        }
    }

    getPidSeason(pid: PidConfiguration) {
        return pid.season ?? PidConfigurationSeasonEnum.ANY
    }

    setSeason(value: any, indexPid: number) {
        const pidConfigurations = arrayIsSet(this.pidConfigurations) ? [...this.pidConfigurations] : []
        const pidConfiguration = pidConfigurations[indexPid]
        if (pidConfiguration.season != value) {
            pidConfiguration.season = value;
            this.pidConfigurations = pidConfigurations;
        }
    }

    predicateSensoEventEnum(sensorEventType: SensorEventType) {
        let keys = Object.keys(sensorEventType).filter(x => !(parseInt(x) >= 0));
        return keys.map(key => {
            return {
                traduction: 'SensorEvent.SensorEventType.' + (sensorEventType as any)[key],
                valueForm: (sensorEventType as any)[key]
            }
        })
    }

    getIconTypePredicate(value: { valueForm: SensorEventType, traduction: string } | undefined): {
        icon?: string,
        svgIcon?: string,
        color: 'primary' | 'warn' | 'accent',
        tooltipText: string
    } | undefined {
        if (value == null || value.valueForm == null) {
            return undefined
        } else if (value.valueForm == SensorEventType.WINTER) {
            return {icon: 'ac_unit', color: "accent", tooltipText: 'sensorEventType.winter'}
        } else if (value.valueForm == SensorEventType.SUMMER) {
            return {icon: 'wb_sunny', color: 'accent', tooltipText: 'sensorEventType.summer'}
        } else if (value.valueForm == SensorEventType.ANY) {
            return {svgIcon: 'winterSummer', color: 'accent', tooltipText: 'sensorEventType.any'}
        } else {
            return {icon: 'alert', color: 'warn', tooltipText: 'sensorEventType.nonPrevisto'}
        }
    }

    get changesEnabled(): boolean {
        return this.enableChangesEmit.value
    }

    set changesEnabled(value: boolean) {
        this.enableChangesEmit.next(value)
    }

    enableDisableChanges() {
        this.changesEnabled = !this.changesEnabled
    }

    enableDisableUpdate() {
        this.form.updateValueAndValidity()
    }
}
